import { Table, RadioChangeEvent, Radio, message, Popover, Button, Row, Col } from "antd";
import { useState, Dispatch, SetStateAction, MutableRefObject } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import DeleteModal from "../UI/ModalComponent/DeleteModal/deletemodal";
import { Dto, Session, Till, User, Workstation, deleteTill } from "../../api/till";
import { UseMutateAsyncFunction, useMutation } from "react-query";
import { AxiosResponse } from "axios";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
interface tillProps {
  selected: number;
  setSelected: Dispatch<SetStateAction<number>>;
  tableKey: number;
  tills: Till[];
  isTillsLoading: boolean;
  Dto: Dto;
  setDto: Dispatch<SetStateAction<Dto>>;
  getTillsMutation: UseMutateAsyncFunction<
    AxiosResponse<any, any>,
    unknown,
    void,
    unknown
  >;
  sessionIdRef: MutableRefObject<string | null>;
}

export const InformationList = ({
  sessionIdRef,
  selected,
  setSelected,
  tableKey,
  tills,
  isTillsLoading,
  Dto,
  setDto,
  getTillsMutation,
}: tillProps) => {
  const { t } = useTranslation("common");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const onChange = (e: RadioChangeEvent) => {
    setSelected(e.target.value);
  };

  const { mutateAsync: deleteTillMutation } = useMutation(
    "deleteTill",
    () => deleteTill(selected, Number(sessionIdRef.current)),
    {
      onSuccess: () => {
        getTillsMutation();
        setSelected(Number(sessionIdRef.current) + 1);
      },
    }
  );

  const columns: {}[] = [
    {
      title: t("select"),
      width: "3rem",
      render: (record: Till) => {
        return (
          <Radio.Group onChange={onChange} value={selected} name="tills">
            <Radio value={record.id} />
          </Radio.Group>
        );
      },
    },
    {
      title: t("Till-number"),
      dataIndex: "code",
      key: "code",
      className: "table-header",
    },
    {
      title: t("session"),
      dataIndex: "sess",
      key: "sess",
      render: (record: Session) => <>{record?.id}</>,
    },
    {
      title: t("user"),
      dataIndex: "user",
      key: "user",
      render: (record: User) => <>{record?.userName}</>,
    },
    {
      title: t("workstation"),
      dataIndex: "workstation",
      key: "workstation",
      render: (record: Workstation) => <>{record?.name}</>,
    },
    {
      title: t("shift-started"),
      dataIndex: "sess",
      key: "sess-started",
      render: (record: Session) => <>{record?.openDate}</>,
    },
    {
      title: t("shift-ended"),
      dataIndex: "sess",
      key: "sess-ended",
      render: (record: Session) => <>{record?.closeDate}</>,
    },
    {
      title: t("action"),
      key: "action",
      width: "3rem",
      render: (record: any) => (
        <Row>
          <Col span={12}>
            <Popover
              content={<div>{t("edit")}</div>}
              mouseEnterDelay={0}
              mouseLeaveDelay={0}
            >
              <Button
                className="Button"
                type="text"
                icon={
                  <EditOutlined style={{ color: "#000", fontSize: "14px" }} />
                }
                onClick={() => {
                  navigate(`/till/${record.id}`, { state: { isEdit: true } });
                }}
                size="small"
              />
            </Popover>
          </Col>
          <Col span={12}>
            <Popover
              content={<div>{t("delete")}</div>}
              mouseEnterDelay={0}
              mouseLeaveDelay={0}
            >
              <Button
                className="Button"
                type="text"
                icon={
                  <DeleteOutlined
                    style={
                      !record.endTime
                        ? {
                          color: "#CDCDCD",
                          fontSize: "14px",
                          cursor: "not-allowed",
                        }
                        : { color: "#F5222D", fontSize: "14px" }
                    }
                  />
                }
                onClick={() => {
                  if (!record.endTime) {
                    message.error("Can't Delete Current Till!");
                  } else {
                    setOpen(true);
                  }
                }}
                size="small"
              />
            </Popover>
          </Col>
        </Row>
      ),
    },
  ];

  return (
    <>
      <DeleteModal
        open={open}
        setOpen={setOpen}
        name={""}
        onOk={() => {
          deleteTillMutation();
        }}
      />
      <Table
        key={tableKey}
        dataSource={tills}
        loading={isTillsLoading}
        pagination={{ pageSize: 10 }}
        columns={columns}
        scroll={{ x: 1000 }}
        className="till-list"
        rowClassName={(record, index) =>
          index % 2 === 0
            ? "table-row-light table-row"
            : "table-row-dark table-row"
        }
        rowKey={(record) => record.id}
        onRow={(record: Till) => {
          return {
            onClick: () => {
              if (record) {
                setSelected(record?.id);
              }
            },
          };
        }}
        onChange={(selectedPage) => {
          if ((selectedPage.current ?? 1) * 10 + 10 > (Dto.limit ?? 1)) {
            setDto({ ...Dto, limit: (selectedPage.current ?? 1) * 10 + 10 });
          }
        }}
      />
    </>
  );
};
